import { useTranslation } from 'react-i18next'
import { M_Fieldset } from 'src/M_Components'
import { ShipmentChargesFormField } from './ShipmentChargesFormField'

export const ShipmentChargesGroup = ({ dataState, setDataState, disabled, style }) => {
    const { t } = useTranslation()

    const groupFields = [
        {
            display: t('LumpSumCode'),
            code: 'LumpSumCode',
            type: 'foreignKey',
            entity: 'LumpSum',
            filterField: 'code',
            labelFields: ['Code'],
            fields: [
                { key: 'Code', value: 'LumpSumCode' },
                { key: 'Name', value: 'LumpSumName' },
                { key: 'Id', value: 'LumpSumId' },
            ],
            favoritesFieldName: 'LumpSumCode', favoritesGroupName: 'ShipmentCharges', favoritesVarKey: 'LumpSumCode', favoritesIdKey: 'LumpSumId',
        },
        {
            display: t('LumpSumName'),
            code: 'LumpSumName',
            type: 'disabled',
            grow: true,
        },
    ]

    return (
        <M_Fieldset
            labelInside
            style={{ width: '100%', boxSizing: 'border-box', ...style }}
            label={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '20px', marginLeft: '10px' }}>
                    <i className='pi pi-tag' style={{ fontSize: '18px' }} />
                    {t('Group')}
                </div>
            }
            elements={
                <div style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap', padding: '10px' }}>
                    {groupFields.map((field, index) => (
                        <ShipmentChargesFormField
                            key={index}
                            fields={field}
                            index={index}
                            data={dataState}
                            setData={setDataState}
                            disabled={disabled}
                        />
                    ))}
                </div>
            }
        />
    )
}
